module.exports = __webpack_public_path__ + "img/hr.c7f36c80.svg";